export default "__VITE_ASSET__pUdz$aQE__"